/* section-shoppable-lookbook.js — extracted from sections/shoppable-lookbook.liquid */
function toggleHotspotPopup(btn) {
    const card = btn.closest('.lookbook-card');
    if (card) {
      const isShowing = card.classList.contains('show-popover');
      document.querySelectorAll('.lookbook-card').forEach(c => c.classList.remove('show-popover'));
      if (!isShowing) {
        card.classList.add('show-popover');
      }
    }
  }
